<template>
    <div id="printVoucher">
    
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CContainer v-if="statuscheck == 1">
    <!-- Display voucher details if voucher is available -->
    <br /><br /><br />
    <CCard class="p-2 card-with-circles" style="border-radius:24px; position:relative;">
        <img :src="voucher.filePath" style="max-width:100%;border-radius:10px" class="text-center" />
        <h3 class="custom-28px-700 text-center mt-3 font-color-928AFD">{{ voucher.Amount }}</h3>
        <CRow style="width:90%;margin:0 auto">
            <div style="width:50%">
                <h3 class="custom-12px-500 font-color-A3A3A3 mt-3">Redeem at</h3>
                <h3 class="custom-14px-500 font-color-191919">
  {{ voucher.location ? voucher.location.join(', ') : 'Location not available' }}
</h3>


                <h3 class="custom-12px-500 font-color-A3A3A3 mt-3">Receipt No</h3>
                <h3 class="custom-14px-500 font-color-191919">{{ voucher.ReceiptNo }}</h3>
            </div>
            <div style="width:50%">
                <h3 class="custom-12px-500 font-color-A3A3A3 mt-3">Valid Until</h3>
                <h3 class="custom-14px-500 font-color-191919">{{ voucher.ValidUntil | moment("DD/MM/YYYY") }}</h3>

                <h3 class="custom-12px-500 font-color-A3A3A3 mt-3">Voucher No</h3>
                <h3 class="custom-14px-500 font-color-191919">{{ voucher.VoucherNo }}</h3>
            </div>
            <div style="width:100%">
                <h3 class="custom-12px-500 font-color-A3A3A3 mt-3">Term & Conditions:</h3>
                <h3 class="custom-12px-500 font-color-191919" v-html="voucher.TermCondition">
                            </h3>
                <hr style="border:1px dashed #E5E5E5" />
            </div>
            <div style="width:50%" class="p-2">
                <img :src="qrCodeUrl" alt="QR Code" style="max-width:100%">
            </div>
            <div style="width:50%" class="p-2">
                <img :src="voucher.ProfilePhoto" style="max-width:100%" class="text-center mt-3" />
            </div>
            <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                <h3 class="custom-12px-400 font-color-171717 mt-1">
                    Voucher Code: <label class="font-color-928AFD">{{ voucher.Code }}</label>
                </h3>
                <CButton class="custom-border-purple text-white mt-1" @click="CheckValid()">Redeem</CButton>
                <CButton class="custom-border-purple text-white mt-1"  v-on:click="printPage"><img src="../assets/img/printer.png" width="20px"/></CButton>
    
            </div>
        </CRow>
    </CCard>
    <br />
</CContainer>

<div v-else-if="statuscheck == 2" class="bg-overflow" style="height:100vh; position:relative;">
    <!-- Voucher already redeemed -->
    <br /><br /><br />
    <div class="p-3 text-center" style="margin-top:20%; position: relative; z-index: 1;">
        <img src="../assets/img/redeem.png" style="max-width:200px" />
        <p class="custom-12px-500 font-color-171717">
            You have already redeemed the voucher for this brand. Please check back later for new offers!
        </p>
        <CButton class="custom-border-purple text-white mt-3" block @click="GoToHome()"><span class="ml-2 mr-2">Refresh</span></CButton>
    </div>
</div>

<div v-else-if="statuscheck == 3" class="bg-overflow" style="height:100vh; position:relative;">
    <!-- Voucher expired -->
    <br /><br /><br />
    <div class="p-3 text-center" style="margin-top:20%; position: relative; z-index: 1;">
        <img src="../assets/img/no-voucher.png" style="max-width:200px" />
        <p class="custom-12px-500 font-color-171717">This voucher has expired.</p>
        <CButton class="custom-border-purple text-white mt-3" block @click="GoToHome()"><span class="ml-2 mr-2" @click="GoToHome()">Refresh</span></CButton>
    </div>
</div>

<div v-else class="bg-overflow" style="height:100vh; position:relative;">
    <!-- No vouchers available -->
    <br /><br /><br />
    <div class="p-3 text-center" style="margin-top:20%; position: relative; z-index: 1;">
        <img src="../assets/img/no-voucher.png" style="max-width:200px" />
        <p class="custom-12px-500 font-color-171717">Currently, no vouchers are available for this brand. Please check again soon!</p>
        <CButton class="custom-border-purple text-white mt-3" block @click="GoToHome()"><span class="ml-2 mr-2">Refresh</span></CButton>
    </div>
</div>

    
            <br />
        </CCol>
    
        <div v-if="isPopupSubmit" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->

                <div class="text-center">
                    <div v-if="this.Error == true" class="mt-1">
                            <CAlert show color="danger">
                                <strong class="text-danger mr-2">Error: {{ Message }}</strong>
                            </CAlert>
                        </div>
                    <div v-if="voucher.status === true">
                        <h3 class="text-success custom-14px-500">Voucher still Valid</h3>
                        <h3 class="custom-18px-600 font-color-171717 text-center mt-3">
                            Are you sure you want to redeem this voucher?
                        </h3>
                        <p class="custom-12px-400 font-color-696969">Once you proceed, the voucher can no longer be used, and the code will be required during payment at the cashier.</p>
                        <h3 class="custom-14px-600 text-left">Approval Password</h3>
                        <CInput type="text" v-model="staffId"/>
                        <CAlert color="info" class="text-left">The "Approval Password" field is optional for staff used. You can leave this field empty if you do not have or do not need an approval password.</CAlert>
                        <h3 class="custom-14px-600 text-left">Location Outlet</h3>
                        <CInput type="text" v-model="outlet"/>
                        <h3 class="custom-14px-600 text-left">Receipt No</h3>
                        <CInput type="text" v-model="receiptNo"/>
                        <CButton class="custom-border-purple mt-4 text-white" block @click="SubmitClaim">
                            <span class="ml-2 mr-2">Yes</span>
                        </CButton>
                        <CButton class="badge-purple mt-2 font-color-928AFD" block @click="closeSubmit">
                            <span class="ml-2 mr-2">No</span>
                        </CButton>
                    </div>
    
                    <div v-else>
                        <h3 class="text-danger custom-14px-500">Voucher fully redeemed / not valid</h3>
                        <h3 class="custom-18px-600 font-color-171717 text-center mt-3">
                            Are you sure you want to redeem this voucher?
                        </h3>
                        <p class="custom-12px-400 font-color-696969">Once you proceed, the voucher can no longer be used, and the code will be required during payment at the cashier.</p>
                        <h3 class="custom-14px-600 text-left">Staff Id</h3>
                        <CInput type="text" class="bg-grey" disabled/>
                        <h3 class="custom-14px-600 text-left">Location Outlet</h3>
                        <CInput type="text" class="bg-grey" disabled/>
                        <h3 class="custom-14px-600 text-left">Receipt No</h3>
                        <CInput type="text" class="bg-grey" disabled/>
         
                      
                        <CButton class="badge-purple mt-2 font-color-928AFD" block @click="closeSubmit">
                            <span class="ml-2 mr-2">Close</span>
                        </CButton>
                    </div>
    
                </div>
            </div>
        </div>


        <div v-if="SuccessPopup" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 100px" src="../assets/img/success.png" />
                    <h3 class="custom-32px-500 custom-24px-600 font-color-171717">Success!</h3>
                    <h3 class="custom-16px-400 text-center">
                        Your redeem voucher is succesfully claim
                    </h3>
                </div>
    
                <CButton class="custom-border-purple text-white" @click="closeSuccess()" block><span class="ml-2 mr-2">Close</span></CButton>
    
    
            </div>
        </div>
        <Footerlayout></Footerlayout>
    </div>
</template>

<script>
import QRCode from 'qrcode-generator';
import Vue from "vue";
import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import Footerlayout from "../containers/TheBottomCustom.vue";
export default {
    name: "Login",
    components: {
        Footerlayout
    },

    data() {
        return {
            backgroundUrl,
            isPopupSubmit: false,
            qrCodeUrl: '',
            qrValue: 'https://app.surpriz.ing/VoucherQr?code=',
            code: 'YM123456',
            VoucherNo: 372673,

            check: {},
            voucher: {},
            user: {},
            codeqr: "",
            greet: {},
            valid: "",
            staffId: "",
            receiptNo: "",
            PhoneNumber: "",
            outlet: "",
            SuccessPopup: false,
            statuscheck: this.$route.query.status,
            Error: false,
            Message: ""
            
        }
    },
    created() {
        this.generateQRCode();
        //this.checkVoucherCode();

    },
    mounted() {

        this.GetVoucher();
        this.GetGreeting();
    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        closeSubmit() {
            this.isPopupSubmit = false;
        },
        openSubmit() {
            this.isPopupSubmit = true;
        },
        generateQRCode() {
            if (this.qrValue && this.voucher) { // Check both values
                console.log("Generating QR code with:", this.qrValue, this.voucher.Code); // Log values
                const qr = QRCode(0, 'L');
                qr.addData(this.qrValue + this.$route.query.code);
                qr.make();
                this.qrCodeUrl = qr.createDataURL(10); // Adjust scale factor as needed
            } else {
                console.error("qrValue or voucher.Code is not defined.");
                console.log("qrValue:", this.qrValue); // Log qrValue
                console.log("voucher.Code:", this.voucher ? this.voucher.Code : 'voucher is undefined'); // Log voucher.Code
            }
        },

        async GetVoucher() {
    try {
        const response = await this.$API.get(this.$GetVoucherByCode + "?code=" + this.$route.query.code);
        if (response.status === 200) {
            this.voucher = response.data;
            this.codeqr = this.voucher.Code;
            console.log("Voucher Data:", this.voucher); // Debug log
            this.generateQRCode();
        } else {
            console.error("Failed to fetch voucher:", response);
        }
    } catch (error) {
        console.error("Error fetching voucher:", error);
    }
},

        async GetGreeting() {
            try {
                const response = await this.$API.get(this.$GetGreeting + "?code=" + this.$route.query.code);
                if (response.status === 200) {
                    this.greet = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async CheckValid() {
            try {
                const response = await this.$API.get(this.$ValidVoucher + "?code=" + this.$route.query.code);
                if (response.status === 200) {
                    this.voucher = response.data; // Assuming response.data is the boolean value
                    this.isPopupSubmit = true;
                } else {
                    console.error("Failed to fetch voucher information:", response);
                }
            } catch (error) {
                console.error("Error fetching voucher information:", error);
            }
        },
        SubmitClaim() {
            const formData = new FormData();
            formData.append("passKey", this.staffId);
            formData.append("code", this.$route.query.code);
            formData.append("location", this.outlet);
            formData.append("receiptNo", this.receiptNo);

            this.$API
                .post(this.$InsertClaim, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data;
                    }
                    if (response.status == 200) {
                            this.SuccessPopup = true;
                            this.isPopupSubmit = false;
                            
                      
                    } else {
                        this.Error = true;
                    this.Message = error.response.data;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data;
                });
        },
        closeSuccess() {
            this.SuccessPopup = false;
            this.$router.push("SubmissionSuccess");
            
        },
        // printPage() {
        //     window.print();
        // },
        printPage() {
      // Print section by ID using vue-html-to-paper
      

      this.$htmlToPaper('printVoucher');
    },
    GoToHome()
    {
        this.$router.push("/");
    }


    }

}
</script>


<style>
.card-with-circles {
    position: relative;
}

@media (max-width: 768px) {
    .card-with-circles::before {
        content: '';
        position: absolute;
        width: 40px;
        height: 40px;
        background: rgba(173, 168, 252, 255);
        /* background-color: rgba(0, 0, 0, 0.1);  */
        border-radius: 50%;
        bottom: 180px;
        /* Positioned 100px from the bottom */
    }
    .card-with-circles::after {
        content: '';
        position: absolute;
        width: 40px;
        height: 40px;
        background: rgba(146, 135, 249, 255);
        border-radius: 50%;
        bottom: 180px;
        /* Positioned 100px from the bottom */
    }
    .card-with-circles::before {
        left: -25px;
        /* Adjust as needed to place on the left */
    }
    .card-with-circles::after {
        right: -25px;
        /* Adjust as needed to place on the right */
    }
}
</style>